module.exports = __webpack_public_path__ + "img/verifikasi-web-icon-2.1b39d56d.svg";